import script from "./EditBusinessTableCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditBusinessTableCell.vue?vue&type=script&lang=ts&setup=true"

import "./EditBusinessTableCell.vue?vue&type=style&index=0&id=31f2ac98&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31f2ac98"]])

export default __exports__